export default __webpack_public_path__ + "static/media/arrow_back.dd625980.svg";